export default {
  state: {
    dnsZoneNames: {},
  },
  mutations: {
    setDnsZoneNames(state, dnsZoneNames) {
      state.dnsZoneNames = dnsZoneNames;
    },
  },
  actions: {},
  getters: {
    getDnsZoneNames: (state) => state.dnsZoneNames,
  },
};
